import { Link } from "react-router-dom";

interface Crumb {
  label: string;
  to?: string;
}

interface BreadcrumbProps {
  items: Crumb[];
  light?: boolean;
}

export default function Breadcrumb({ items, light = false }: BreadcrumbProps) {
  const linkClass = light
    ? "text-background-200 transition hover:text-background-50"
    : "text-foreground-600 transition hover:text-primary-700";
  const sepClass = light ? "text-background-50/50" : "text-foreground-400";
  const currentClass = light
    ? "font-medium text-background-50"
    : "font-medium text-foreground-950";

  return (
    <nav aria-label="面包屑导航" className="flex flex-wrap items-center gap-1.5 text-sm">
      {items.map((item, index) => (
        <span key={`${item.label}-${index}`} className="flex items-center gap-1.5">
          {index > 0 && <i className={`ri-arrow-right-s-line ${sepClass}`}></i>}
          {item.to ? (
            <Link to={item.to} className={linkClass}>
              {item.label}
            </Link>
          ) : (
            <span className={currentClass}>{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}